export enum LocalStorageKeys {
    lastSSODomain = 'lastSSODomain',
    rememberSSOEmail = 'rememberSSOEmail'
}
